/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/miro" */ '@atlassian/logo-third-party/miro'
		).then((m) => m.MiroIcon),
	{ moduleId: '@atlassian/logo-third-party/miro' },
);

const LazyMiroIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-miro" */ './utils').then((m) => m.MiroIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/miro/icon' },
);

const LazyMiroSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-miro-search-result" */ './utils').then(
			(m) => m.MiroSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/miro/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const MiroIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyMiroIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const MiroSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyMiroSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
